import { render, staticRenderFns } from "./FooterBlock.vue?vue&type=template&id=32d6ad1b&scoped=true"
import script from "./FooterBlock.vue?vue&type=script&lang=ts"
export * from "./FooterBlock.vue?vue&type=script&lang=ts"
import style0 from "./FooterBlock.vue?vue&type=style&index=0&id=32d6ad1b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d6ad1b",
  null
  
)

export default component.exports